// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ProjectDashboardPage } from "./pages/ProjectDashboardPage";
import { ProjectWorkbenchPage } from "./pages/ProjectWorkbenchPage";
import { ProjectSourcesPage } from "./pages/ProjectSourcesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { Login } from "./pages/Login";
import { OnboardingProvider } from "./context/OnboardingContext";
import { BillingProvider } from "./context/BillingContext";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { BillingPage } from "./pages/BillingPage";

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <BillingProvider>
        <OnboardingProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ProjectDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sources"
              element={
                <ProtectedRoute>
                  <ProjectSourcesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workbench"
              element={
                <ProtectedRoute>
                  <ProjectWorkbenchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        </OnboardingProvider>
      </BillingProvider>
    </AuthProvider>
  );
};
